import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
var PageHeader = function PageHeader() {
  return import('@/components/molecules/PageHeader');
};
var AssetListItem = function AssetListItem() {
  return import('@/components/molecules/AssetListItem');
};
var LazyImage = function LazyImage() {
  return import('@/components/atoms/LazyImage');
};
var RarityIcon = function RarityIcon() {
  return import('@/components/atoms/RarityIcon');
};
var AvatarDetailForModal = function AvatarDetailForModal() {
  return import('@/components/organisms/AvatarDetailForModal');
};
var Modal = function Modal() {
  return import('@/components/organisms/Modal');
};
var UnitComment = function UnitComment() {
  return import('@/components/molecules/UnitComment');
};
var BuyMemoriaModal = function BuyMemoriaModal() {
  return import('@/components/organisms/BuyMemoriaModal');
};
export default {
  components: {
    PageHeader: PageHeader,
    AssetListItem: AssetListItem,
    LazyImage: LazyImage,
    RarityIcon: RarityIcon,
    AvatarDetailForModal: AvatarDetailForModal,
    Modal: Modal,
    UnitComment: UnitComment,
    BuyMemoriaModal: BuyMemoriaModal
  },
  data: function data() {
    return {
      memoriaMasters: [],
      selectedMemoria: {},
      isAvatarDetailForModalShown: false,
      isUnitImageShown: false,
      isBuyMemoriaModalShown: false
    };
  },
  computed: {
    getHeroType: function getHeroType() {
      return useHeroMaster().getHeroType;
    },
    isLoggedIn: function isLoggedIn() {
      return useAuthStore().isLoggedIn;
    },
    sortedMemorias: function sortedMemorias() {
      var memorias = this.$util.clone(this.memoriaMasters);
      memorias.sort(function (p, c) {
        if (p.memoriaType < c.memoriaType) return -1;
        if (p.memoriaType > c.memoriaType) return 1;
        return 0;
      });
      memorias.sort(function (p, c) {
        if (p.attribute < c.attribute) return -1;
        if (p.attribute > c.attribute) return 1;
        return 0;
      });
      memorias.sort(function (p, c) {
        if ((p.rarity || 1) < (c.rarity || 1)) return 1;
        if ((p.rarity || 1) > (c.rarity || 1)) return -1;
        return 0;
      });
      return memorias;
    }
  },
  beforeMount: function beforeMount() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this.isLoggedIn) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            _context.next = 4;
            return useConsumableStore().fetchConsumeMyItems();
          case 4:
            _this.memoriaMasters = _this.getAvatarsInfo(useMemoriaMaster().getMemoriaTypes.filter(function (memoria) {
              return memoria.memoriaPart == 1;
            }));
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    buy: function buy() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _this2.$memoriaService.buyMemoria(_this2.selectedMemoria.memoriaType);
            case 3:
              _context2.next = 5;
              return useConsumableStore().fetchConsumeMyItems();
            case 5:
              _this2.isBuyMemoriaModalShown = false;
              _this2.$toast.success('Success.');
              _context2.next = 13;
              break;
            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              console.error(_context2.t0);
              _this2.$toast.error('Error.');
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 9]]);
      }))();
    },
    getAvatarsInfo: function getAvatarsInfo(avatars) {
      var _this3 = this;
      return avatars.map(function (avatarTmp) {
        var heroType = _this3.getHeroType(avatarTmp.heroType);
        var avatar = _objectSpread(_objectSpread({}, heroType), avatarTmp);
        return avatar;
      });
    },
    frameSrc: function frameSrc(memoria) {
      if (!memoria.attribute) {
        return;
      }
      return require("~/assets/images/frames/".concat(memoria.attribute, ".png"));
    },
    openDetailModal: function openDetailModal(memoria) {
      this.isAvatarDetailForModalShown = true;
      this.selectedMemoria = memoria;
    },
    showBuyMemoriaModal: function showBuyMemoriaModal(memoria) {
      this.selectedMemoria = memoria;
      this.isAvatarDetailForModalShown = false;
      this.isBuyMemoriaModalShown = true;
    }
  }
};